"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldVisibility = exports.FieldDisplayType = void 0;
let FieldVisibility = exports.FieldVisibility = /*#__PURE__*/function (FieldVisibility) {
  FieldVisibility["SHOW"] = "Show";
  FieldVisibility["FORM"] = "Form";
  FieldVisibility["TABLE"] = "Table";
  FieldVisibility["HIDE"] = "Hide";
  return FieldVisibility;
}({});
let FieldDisplayType = exports.FieldDisplayType = /*#__PURE__*/function (FieldDisplayType) {
  FieldDisplayType["SELECT"] = "Select";
  FieldDisplayType["RADIO"] = "Radio";
  FieldDisplayType["TOGGLE"] = "Toggle";
  FieldDisplayType["CHECKBOX"] = "Checkbox";
  return FieldDisplayType;
}({});